import React, { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import './Colorbar.css'; // We'll define styles here

const Colorbardh = ({input}) => {
  const map = useMap();

  useEffect(() => {
    const colorBarControl = L.control({ position: 'bottomright' });
    
    colorBarControl.onAdd = () => {
      const div = L.DomUtil.create('div', 'text-n-8 info color-bar');
        
        
      let imageUrl = input[0].cb_link;
        
        
      div.innerHTML = `
        <div class="colorbar-container">
        <img src="${imageUrl}"/>
        </div>
      `;
      return div;
    };

    

    colorBarControl.addTo(map);

    return () => {
      map.removeControl(colorBarControl);
    };
  }, [map,input]);

  return null;
};

export default Colorbardh;
